import { Input } from '@repo/shadcn';
import { ChangeEvent, FC } from 'react';
import { BiSearchAlt } from 'react-icons/bi';

interface SearchFilterProps {
    table?: any;
    placeholder: string;
    onChangeSearch: (search: ChangeEvent<HTMLInputElement>) => void;
    value?: string;
}
export const TextSearchFilter: FC<SearchFilterProps> = ({
    placeholder,
    onChangeSearch,
    value,
}) => {
    return (
        <div>
            {/* <Label>Search by {placeholder}</Label> */}
            <div className="relative">
                <BiSearchAlt className="absolute left-3 top-1/2 -translate-y-1/2 transform text-gray-400" />
                <Input
                    type="search"
                    placeholder={`Search by ${placeholder}...`}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        onChangeSearch(e)
                    }
                    className="h-[40px] w-[300px] pl-8 pr-4 text-[14px] focus-visible:ring-1"
                    value={value}
                />
            </div>
        </div>
    );
};

export default TextSearchFilter;
